import { CLOActionTypes } from './types';
import { all, takeLatest, call, put } from 'redux-saga/effects';
import Services from '../../services';
import {
  fetchTopThreeCLOSuccess,
  fetchTopThreeCLOFailure,
  fetchCLODetailsSuccess,
  fetchCLODetailsFailure,
  fetchCLOListingSuccess,
  fetchCLOListingFailure,
  addCLOEventSuccess,
  addCLOEventFailure,
  addCLOAsFavouriteSuccess,
  addCLOAsFavouriteFailure,
  removeCLOAsFavouriteSuccess,
  removeCLOAsFavouriteFailure,
  hideCLOSuccess,
  hideCLOFailure,
  unhideCLOSuccess,
  unhideCLOFailure
} from './actions';

export function* doFetchTopThreeCLO(request: any) {
  try {
    const response = yield call(
      Services.clo.fetchCLOListingService,
      request.payload
    );
    if (!response.error) {
      yield put(fetchTopThreeCLOSuccess(response));
    } else {
      const errMsg = response.error.message;
      yield put(fetchTopThreeCLOFailure(errMsg));
    }
  } catch (error) {
    const errorMsg = error.message ? error.message : error;
    yield put(fetchTopThreeCLOFailure(errorMsg));
  }
}

export function* doFetchCLOListing(request: any) {
  try {
    const response = yield call(
      Services.clo.fetchCLOListingService,
      request.payload
    );
    if (!response.error) {
      yield put(fetchCLOListingSuccess(response));
    } else {
      const errMsg = response.error.message;
      yield put(fetchCLOListingFailure(errMsg));
    }
  } catch (error) {
    const errorMsg = error.message ? error.message : error;
    yield put(fetchCLOListingFailure(errorMsg));
  }
}

export function* doFetchCLODetails(request: any) {
  try {
    const response = yield call(
      Services.clo.fetchCLODetailsService,
      request.payload
    );
    if (!response.error) {
      yield put(fetchCLODetailsSuccess(response));
    } else {
      const errMsg = response.error.message;
      yield put(fetchCLODetailsFailure(errMsg));
    }
  } catch (error) {
    const errorMsg = error.message ? error.message : error;
    yield put(fetchCLODetailsFailure(errorMsg));
  }
}

export function* doAddCLOEvent(request: any) {
  try {
    const response = yield call(Services.clo.addCLOEvent, request.payload);
    if (!response.error) {
      yield put(addCLOEventSuccess(response));
    } else {
      const errMsg = response.error.message;
      yield put(addCLOEventFailure(errMsg));
    }
  } catch (error) {
    const errorMsg = error.message ? error.message : error;
    yield put(addCLOEventFailure(errorMsg));
  }
}

export function* doAddCLOAsFavourite(request: any) {
  try {
    const response = yield call(
      Services.clo.addOrRemoveCLOAsFavourite,
      request.payload
    );
    if (!response.error) {
      yield put(addCLOAsFavouriteSuccess(response));
    } else {
      const errMsg = response.error.message;
      yield put(addCLOAsFavouriteFailure(errMsg));
    }
  } catch (error) {
    const errorMsg = error.message ? error.message : error;
    yield put(addCLOAsFavouriteFailure(errorMsg));
  }
}

export function* doRemoveCLOAsFavourite(request: any) {
  try {
    const response = yield call(
      Services.clo.addOrRemoveCLOAsFavourite,
      request.payload
    );
    if (!response.error) {
      yield put(removeCLOAsFavouriteSuccess(response));
    } else {
      const errMsg = response.error.message;
      yield put(removeCLOAsFavouriteFailure(errMsg));
    }
  } catch (error) {
    const errorMsg = error.message ? error.message : error;
    yield put(removeCLOAsFavouriteFailure(errorMsg));
  }
}

export function* doHideCLO(request: any) {
  try {
    const response = yield call(Services.clo.hideOrUnhideCLO, request.payload);
    if (!response.error) {
      yield put(hideCLOSuccess(response));
    } else {
      const errMsg = response.error.message;
      yield put(hideCLOFailure(errMsg));
    }
  } catch (error) {
    const errorMsg = error.message ? error.message : error;
    yield put(hideCLOFailure(errorMsg));
  }
}

export function* doUnhideCLO(request: any) {
  try {
    const response = yield call(Services.clo.hideOrUnhideCLO, request.payload);
    if (!response.error) {
      yield put(unhideCLOSuccess(response));
    } else {
      const errMsg = response.error.message;
      yield put(unhideCLOFailure(errMsg));
    }
  } catch (error) {
    const errorMsg = error.message ? error.message : error;
    yield put(unhideCLOFailure(errorMsg));
  }
}

export function* onFetchTopThreeCLO() {
  yield takeLatest(
    CLOActionTypes.FETCH_TOP_THREE_CLO_START,
    doFetchTopThreeCLO
  );
}

export function* onFetchCLOListing() {
  yield takeLatest(CLOActionTypes.FETCH_CLO_LISTING_START, doFetchCLOListing);
}

export function* onFetchCLODetails() {
  yield takeLatest(CLOActionTypes.FETCH_CLO_DETAILS_START, doFetchCLODetails);
}

export function* onAddCLOEvent() {
  yield takeLatest(CLOActionTypes.ADD_CLO_EVENT_START, doAddCLOEvent);
}

export function* onAddCLOAsFavourite() {
  yield takeLatest(
    CLOActionTypes.ADD_CLO_AS_FAVOURITE_START,
    doAddCLOAsFavourite
  );
}

export function* onRemoveCLOAsFavourite() {
  yield takeLatest(
    CLOActionTypes.REMOVE_CLO_AS_FAVOURITE_START,
    doRemoveCLOAsFavourite
  );
}

export function* onHideCLO() {
  yield takeLatest(CLOActionTypes.HIDE_CLO_START, doHideCLO);
}

export function* onUnhideCLO() {
  yield takeLatest(CLOActionTypes.UNHIDE_CLO_START, doUnhideCLO);
}

export function* cloSagas() {
  yield all([
    call(onFetchTopThreeCLO),
    call(onFetchCLOListing),
    call(onFetchCLODetails),
    call(onAddCLOEvent),
    call(onAddCLOAsFavourite),
    call(onRemoveCLOAsFavourite),
    call(onHideCLO),
    call(onUnhideCLO)
  ]);
}

export default cloSagas;
